<template>
  <div class="w-full flex items-center gap-2">
    <button v-if="starredFilter" @click="() => {update('')}"
            class="text-yellow-500 p-1 text-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0">
      <Icon icon="material-symbols:star" width="24"
            height="24"/>
    </button>
    <button v-if="!starredFilter" @click="() => {update('starred')}"
            class="p-1 text-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0">
      <Icon icon="material-symbols:star-outline" width="24"
            height="24"/>
    </button>
    {{headerName}}
  </div>
</template>
<script lang="ts">
import {defineComponent, ref} from 'vue'
import {Icon} from '@iconify/vue';

export default defineComponent({
  setup() {
    const headerName = ref("");
    const starredFilter = ref("");
    return {
      headerName,
      starredFilter
    }
  },
  components: {
    Icon
  },
  mounted() {
    /* @ts-ignore */
    this.headerName = this.params?.headerName
    /* @ts-ignore */
    this.starredFilter = this.params?.starredFilter
  },
  watch: {
    starredFilter: {
      handler(newValue) {
        this.starredFilter = newValue
      },
    },
  },
  methods: {
    update(val: string) {
      this.starredFilter = val
      /* @ts-ignore */
      this.params?.setStarredFilter(val)
    }
  }
})
</script>
